(function() {
  var __blocks__ = {};
  (function() {
    var element = document.getElementById("blocks-script");
    var attribute = a = element ? element.getAttribute("data-blocks") : '';
    var blocks = a.split(",").filter(Boolean);

    for (var i = 0; i < blocks.length; i++) {
      __blocks__[blocks[i]] = true;
    }
  })();
  (function() {
  if (!__blocks__["_pdp-returns-shipping-layer"] && !Shopify.designMode) return;
  try {
    /* Benvel PDP returns/shipping one-tap layer — Story 4.13.
     Progressive enhancement: upgrades the trigger <a> anchor to open a <dialog> modal.
     Without JS, the anchor remains a working deep-link to the full returns policy page.
     No framework. No external dependencies. */
  (function () {
    'use strict';

    var layers = document.querySelectorAll('[data-bv-returns-shipping-layer]');
    if (!layers.length) {
      return;
    }

    layers.forEach(function (layer) {
      var trigger = layer.querySelector('[data-bv-trigger]');
      var dialog = layer.querySelector('[data-bv-dialog]');
      var closeBtn = layer.querySelector('[data-bv-dialog-close]');

      /* Feature-detect: if showModal is not available (very old Safari),
         leave the trigger as a plain anchor. */
      if (!trigger || !dialog || typeof dialog.showModal !== 'function') {
        return;
      }

      function openDialog() {
        dialog.showModal();
        if (closeBtn) {
          closeBtn.focus();
        }
      }

      function closeDialog() {
        dialog.close();
        trigger.focus();
      }

      /* Upgrade the trigger for assistive technology. */
      trigger.setAttribute('role', 'button');

      trigger.addEventListener('click', function (event) {
        event.preventDefault();
        openDialog();
      });

      /* Enter / Space for <a role="button"> keyboard pattern. */
      trigger.addEventListener('keydown', function (event) {
        if (event.key === 'Enter' || event.key === ' ') {
          event.preventDefault();
          openDialog();
        }
      });

      if (closeBtn) {
        closeBtn.addEventListener('click', function () {
          closeDialog();
        });
      }

      /* Backdrop click: detect clicks outside the dialog bounding rect. */
      dialog.addEventListener('click', function (event) {
        var rect = dialog.getBoundingClientRect();
        var insideDialog =
          event.clientX >= rect.left &&
          event.clientX <= rect.right &&
          event.clientY >= rect.top &&
          event.clientY <= rect.bottom;
        if (!insideDialog) {
          closeDialog();
        }
      });

      /* ESC is handled natively by <dialog>; restore focus to trigger after close. */
      dialog.addEventListener('close', function () {
        trigger.focus();
      });
    });
  })();
  } catch(e) { console.error(e); }
})();

})();
